import React, { useEffect, useState } from "react";
import { Link, NavLink, useLocation } from "react-router-dom";
import { buttonClass } from "./ui";

const NAV = [
  { to: "/brands", label: "取り扱い商品" },
  { to: "/#flow", label: "ご利用の流れ" },
  { to: "/contact", label: "お問い合わせ" },
  { to: "/about", label: "当社について" },
];

const Header = () => {
  const [open, setOpen] = useState(false);
  const location = useLocation();

  useEffect(() => setOpen(false), [location.pathname, location.hash]);

  useEffect(() => {
    document.body.style.overflow = open ? "hidden" : "";
    return () => {
      document.body.style.overflow = "";
    };
  }, [open]);

  const navClass = ({ isActive }) =>
    `flex min-h-11 items-center text-[14px] transition-colors ${
      isActive && !NAV.find((n) => n.to.includes("#") && location.hash)
        ? "text-ink"
        : "text-ink-2 hover:text-ink"
    }`;

  return (
    <>
      <header className="sticky top-0 z-50 border-b border-line bg-white/85 backdrop-blur-xl backdrop-saturate-150">
        <div className="mx-auto flex h-14 max-w-6xl items-center justify-between px-4 md:h-16 md:px-8">
          <Link to="/" className="flex min-h-11 items-center" aria-label="CAMARAGO トップへ">
            <img
              src="/images/camarago_wordmark.png"
              alt="CAMARAGO"
              className="h-[18px] w-auto md:h-5"
            />
          </Link>

          <nav className="hidden items-center gap-8 md:flex" aria-label="メインメニュー">
            {NAV.map((n) =>
              n.to.includes("#") ? (
                <Link
                  key={n.to}
                  to={n.to}
                  className="flex min-h-11 items-center text-[14px] text-ink-2 transition-colors hover:text-ink"
                >
                  {n.label}
                </Link>
              ) : (
                <NavLink key={n.to} to={n.to} className={navClass}>
                  {n.label}
                </NavLink>
              )
            )}
            <Link to="/wizard" className={buttonClass("primary", "!min-h-9 !px-4 !text-[14px]")}>
              診断をはじめる
            </Link>
          </nav>

          <button
            type="button"
            className="-mr-2 flex h-11 w-11 items-center justify-center text-ink md:hidden"
            aria-label={open ? "メニューを閉じる" : "メニューを開く"}
            aria-expanded={open}
            onClick={() => setOpen((v) => !v)}
          >
            <svg
              width="20"
              height="20"
              viewBox="0 0 20 20"
              fill="none"
              stroke="currentColor"
              strokeWidth="1.8"
              strokeLinecap="round"
              aria-hidden="true"
            >
              {open ? <path d="M4 4l12 12M16 4L4 16" /> : <path d="M2 6h16M2 14h16" />}
            </svg>
          </button>
        </div>
      </header>

      {/* ヘッダーのぼかし効果の中に置くと全画面にならないため、ヘッダーの外に出す */}
      {open && (
        <div className="fixed inset-x-0 bottom-0 top-14 z-[60] overflow-y-auto bg-white md:hidden">
          <nav className="flex flex-col px-6 pt-4" aria-label="メインメニュー">
            <Link
              to="/"
              className="flex min-h-14 items-center border-b border-line text-[22px] font-semibold"
            >
              トップ
            </Link>
            {NAV.map((n) => (
              <Link
                key={n.to}
                to={n.to}
                className="flex min-h-14 items-center border-b border-line text-[22px] font-semibold"
              >
                {n.label}
              </Link>
            ))}
            <Link to="/wizard" className={buttonClass("primary", "mt-8 w-full")}>
              診断をはじめる
            </Link>
          </nav>
        </div>
      )}
    </>
  );
};

export default Header;
